<template>
  <li class="activityItem clearfix" :class="min?'min':''" @click="intoInformationActivityDetail(item.id,'activity')">
    <img v-if="min" v-bind:src="imgPath+item.image" :onerror="imgError" class="l"
         width="240" height="142"
         alt="活动图片">
    <img v-if="!min" v-bind:src="imgPath+item.image" :onerror="imgError" class="l"
         width="260" height="160"
         alt="活动图片">
    <div class="activityContent">
      <h3 class="ellip">{{item.title}}</h3>
      <div class="time">时间：{{item.startDate}} ~ {{item.endDate}}</div>
      <div class="location ellip">地址：{{item.address}}</div>
      <div class="organizer ellip">主办方：{{item.source}}</div>
    </div>
    <div class="tips" v-if="item.isJoin">报名</div>
  </li>
</template>

<script>
  import {store} from '../store/store';
  import {imgPath} from "../common/config";

  export default {
    name: 'activity',
    props: ['item','min'],
    data() {
      return {
        imgError: store.imgError,
        imgPath:imgPath
      }
    },
    created(){
      if(this.item.summary.length>=90){
        this.item.summary=this.item.summary.replace(/[^\u4e00-\u9fa5\w]/g,'')+'...'
      }
    },
    methods:{
      intoInformationActivityDetail(id,type) {
        this.$emit('toDetail',id,type)
      }
    }
  }
</script>

<style scoped lang="sass">
  .web2
    .activityItem
      &:hover
        h3
          color: $themecolor2
  .min
    padding: 0!important
    height: 142px!important
    .tips
      top: 0
      left: 0
    p
      margin-bottom: 10px!important
    h3
      margin-bottom: 25px!important
    &:hover
      background: #fff!important
  .activityItem
    position: relative
    height: 220px
    padding: 30px
    cursor: pointer
    h3
      margin-bottom: 26px
      height: 30px
      font-size: 18px
      font-weight: normal
      line-height: 30px
      color: #333
    p
      margin-bottom: 15px
      height: 48px
      font-size: 14px
      line-height: 24px
      color: #333
    img
      margin-right: 30px
    &:hover
      background: #f8f8f8
      h3
        color: $themecolor1
        text-decoration: underline
      img
        opacity: 0.8

  .activityContent
    position: relative
    margin: 0 auto
    overflow: hidden
    cursor: pointer
    .time, .location, .organizer
      margin-bottom: 12px
      padding-left: 25px
      height: 18px
      font-size: 14px
      color: #666
    .time
      background: url("../assets/images/actClock.png") no-repeat
    .location
      background: url("../assets/images/actAddr.png") no-repeat
    .organizer
      background: url("../assets/images/floor.png") no-repeat 0 100%
  .tips
    position: absolute
    left: 30px
    top: 30px
    width: 60px
    height: 22px
    text-align: center
    line-height: 22px
    font-size: 14px
    color: #fff
    background: #df4a43
</style>
